import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { ServicesModule } from './services/services.module';

@NgModule({
  imports: [
    ServicesModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class CoreModule {}
